import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import parse from 'html-react-parser';
import { Snackbar, withStyles, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Cancel';
import InfoIcon from '@material-ui/icons/Info';
import PropTypes from 'prop-types';

import { readCookie, createCookie, getCookieMessage } from '../../utils';
import { getCookieConsent } from '../../reducers/portalConfig';
import styles from './styles';

const CookiePolicyBanner = (props) => {
  const { classes, cookieConsent } = props;
  const [state, setState] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
    root: classes.rootDark,
    content: '',
  });

  const { vertical, horizontal, open, root, content } = state;

  const handleClose = () => {
    setState({ ...state, open: false });
    const cookie = readCookie('cpb');
    if (cookie === null || cookie.toLowerCase() === 'true') {
      createCookie('cpb', 'false', 365, '/');
    }
  };

  useEffect(() => {
    if (cookieConsent) {
      const rootClass = (cookieConsent.theme === 'light' ? classes.rootLight : classes.rootDark);
      const contentText = getCookieMessage(cookieConsent.message);
      const cookie = readCookie('cpb');
      if ((!cookie || cookie.toLowerCase() === 'true')) {
        setState({ ...state,
          root: rootClass,
          content: contentText,
          vertical: cookieConsent.position,
          open: cookieConsent.enabled,
        });
      }
    }
  }, [cookieConsent]);

  return (
    <div id="cookie-policy-container">
      <Snackbar
        classes={{
          root,
        }}
        open={open}
        anchorOrigin={{ vertical, horizontal }}
      >
        <div>
          <div className={classes.infoContainer}>
            <IconButton className={classes.closeButton} color="inherit">
              <InfoIcon className={classes.iconInfo} />
            </IconButton>
          </div>
          <div className={classes.messageContainer}>
            {parse(content)}
          </div>
          <div className={classes.closeContainer}>
            <IconButton className={classes.closeButton} color="inherit" onClick={handleClose}>
              <CloseIcon className={classes.icon} />
            </IconButton>
          </div>
        </div>
      </Snackbar>
    </div>
  );
};


const mapStateToProps = state => ({
  cookieConsent: getCookieConsent(state),
});

CookiePolicyBanner.propTypes = {
  classes: PropTypes.shape({}),
  cookieConsent: PropTypes.shape({}),
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {}),
)(CookiePolicyBanner);




// WEBPACK FOOTER //
// ./src/components/CookiePolicyBanner/index.js